<div class="footer-wrapper">
  <footer class="premium-footer">
    <section class="footer-content">
      <div class="container">
        <div class="footer-grid">
          <!-- Newsletter & Social Section -->
          <div class="footer-column newsletter-column">
            <h6 class="footer-title">Subscribe to our Newsletter</h6>
            <p class="footer-subtitle">Stay updated with our latest offers and news</p>
            <div class="newsletter-form">
              <input 
                type="email" 
                class="newsletter-input" 
                [(ngModel)]="emailN" 
                maxlength="50"
                (keypress)="preventSpace($event)" 
                placeholder="Enter your email" 
                aria-label="Email"
              />
              <button 
                type="button" 
                class="newsletter-btn" 
                [disabled]="isEmailValid()"
                (click)="getDeals()"
              >
                Subscribe
              </button>
            </div>
            <div class="social-links">
              <a href="https://facebook.com/exobe.africa" target="_blank" class="social-icon" aria-label="Facebook">
                <i class="fa fa-facebook-f"></i>
              </a>
              <a href="https://twitter.com/exobe" target="_blank" class="social-icon" aria-label="Twitter">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M18.901 1.153h3.68l-8.04 9.557L24 22.846h-7.406l-5.8-7.584-6.638 7.584H1.128l8.659-9.928L0 1.153h7.594l5.243 6.932L18.901 1.153zm-1.626 19.831h2.039L6.882 3.257H4.697L17.275 20.984z"/>
                </svg>
              </a>
              <a href="https://www.instagram.com/exobe.africa" target="_blank" class="social-icon" aria-label="Instagram">
                <i class="fa fa-instagram"></i>
              </a>
              <a href="https://pinterest.com/exobe" target="_blank" class="social-icon" aria-label="Pinterest">
                <i class="fa fa-pinterest"></i>
              </a>
              <a href="https://www.tiktok.com/@exobe" target="_blank" class="social-icon" aria-label="TikTok">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M21.25 7.48c-1.99-.1-3.77-.79-5.27-2.23V14.1c0 4.49-3.64 7.89-7.93 7.89-1.58 0-3.05-.44-4.29-1.2-.47-.29-.6-.93-.29-1.39.29-.46.92-.6 1.39-.31.93.55 1.99.83 3.18.83 3.22 0 5.86-2.6 5.86-5.82V3.5c0-.41.24-.79.64-.95.39-.16.84-.07 1.15.24 1.36 1.44 3.09 2.25 5.03 2.34.52.03.94.46.94.98v1.4c0 .56-.47 1.01-1.01.99zm-11.45 9.6c-1.81 0-3.28-1.48-3.28-3.31 0-1.82 1.47-3.3 3.28-3.3.55 0 1.08.13 1.55.38.34.18.76.17 1.1-.03.34-.2.55-.56.55-.96V8.12c-1.09-.3-2.25-.33-3.38-.07-2.83.65-4.86 3.17-4.86 6.11 0 3.46 2.79 6.27 6.23 6.27 2.23 0 4.3-1.18 5.42-3.13.17-.28.21-.61.1-.92-.12-.31-.36-.55-.68-.68-.58-.2-1.21-.04-1.58.43-.79.97-1.97 1.6-3.34 1.6z"/>
                </svg>
              </a>
            </div>
          </div>

          <!-- Categories Section -->
          <div class="footer-column categories-column">
            <h6 class="footer-title">Categories</h6>
            <ul class="footer-links">
              <li *ngFor="let subCategory of staticSubCategories">
                <a 
                  (click)="navigateToStaticSubCategory(subCategory)" 
                  class="footer-link"
                >
                  {{ subCategory.name }}
                </a>
              </li>
            </ul>
          </div>

          <!-- Explore Section -->
          <div class="footer-column">
            <h6 class="footer-title">Explore</h6>
            <ul class="footer-links">
              <li>
                <a 
                  href="#" 
                  [ngClass]="{ active: currUrl == 'terms-and-condition' }" 
                  (click)="showDocumentContent('termsConditions', $event)" 
                  class="footer-link"
                >
                  Terms & Conditions
                </a>
              </li>
              <li>
                <a 
                  href="#" 
                  [ngClass]="{ active: currUrl == 'privacy-policy' }" 
                  (click)="showDocumentContent('privacyPolicy', $event)" 
                  class="footer-link"
                >
                  Privacy Policy
                </a>
              </li>
              <li>
                <a 
                  href="#" 
                  [ngClass]="{ active: currUrl == 'aboutUs' }" 
                  (click)="showDocumentContent('aboutUs', $event)" 
                  class="footer-link"
                >
                  About Us
                </a>
              </li>
            </ul>
          </div>

          <!-- Help Section -->
          <div class="footer-column">
            <h6 class="footer-title">Help</h6>
            <ul class="footer-links">
              <li>
                <a 
                  href="#" 
                  [ngClass]="{ active: currUrl == 'faq' }" 
                  (click)="showDocumentContent('faq', $event)" 
                  class="footer-link"
                >
                  FAQ's
                </a>
              </li>
              <li>
                <a 
                  [ngClass]="{ active: currUrl == 'contactUs' }" 
                  routerLink="/contactUs" 
                  class="footer-link"
                >
                  Contact Us
                </a>
              </li>
              <li>
                <a 
                  [ngClass]="{ active: currUrl == 'referal' }" 
                  routerLink="/referal" 
                  class="footer-link"
                >
                  Refer Now
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  </footer>
</div>

<!-- Document Modal Component -->
<app-document-modal></app-document-modal>
